<template>
  <nav :class="['navbar navbar-expand-lg p-0', { 'scrolled': isScrolled }]">
    <div class="container">
      <router-link to="/" class="navbar-brand" @click="closeNavbar">
        <!-- <img :src="require('/src/assets/images/logo2.svg')" alt="Logo"  /> -->
        <img src="../../assets/images/logo.svg" />
      </router-link>

      <button ref="navbarToggler" class="navbar-toggler" type="button" @click="toggleNavbar" aria-controls="navbarNav"
        aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav" ref="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link to="/" class="nav-link" @click="closeNavbar">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/about-us" class="nav-link" @click="closeNavbar">About</router-link>
          </li>
          <!-- Mega Menu for Services -->
          <li class="nav-item mega-dropdown" @mouseenter="openMenu('services')" @mouseleave="closeMenu">
            <router-link to="/service" class="nav-link"> Services <i class="fa fa-angle-down"></i></router-link>
            <div class="mega-menu" v-show="activeMenu === 'services'">
              <div class="row">
                <div class="col-md-3">
                  <img :src="require('/src/assets/images/nav-services.jpg')" />  
                </div>
                <div class="col-md-3">
                  <div class="dropdown-container" @click="toggleSubMenu('web-dev')"></div>
                 <p><router-link to="/service/detail/product-development" class="dropdown-item" @click="closeNavbar"> <img :src="require('/src/assets/images/customsoftware.png')" class="width-40" /> <strong>Product Development</strong></router-link>
                  
                  <a href="/service/detail/product-development#custom-software-development" class="dropdown-item ml11" @click="closeNavbar"> Custom Software Development</a>
                  <a href="/service/detail/product-development#why-choose-our-custom-software-development-services" class="dropdown-item ml11" @click="closeNavbar"> Why Choose Us?</a>
                  <a href="/service/detail/product-development#technologies-we-use" class="dropdown-item ml11" @click="closeNavbar"> Technologies We Use</a>
                  <a href="/service/detail/product-development#our-process" class="dropdown-item ml11" @click="closeNavbar"> Our Process</a>
                </p> 
                <p><router-link to="/service/detail/mobile-app-development" class="dropdown-item" @click="closeNavbar"> <img :src="require('/src/assets/images/mobile-app.png')" class="width-40" /> <strong>Mobile App Development</strong></router-link>
                  
                  <a href="/service/detail/mobile-app-development#our-development-process" class="dropdown-item ml11" @click="closeNavbar"> Why Mobile App</a>
                  <a href="/service/detail/mobile-app-development#our-app-development-expertise" class="dropdown-item ml11" @click="closeNavbar"> Our Development Process</a>
                  <a href="/service/detail/mobile-app-development#ready-to-build-your-mobile-app" class="dropdown-item ml11" @click="closeNavbar"> Ready to Build Your Mobile App?</a>
                </p>  </div>  
                <div class="col-md-3">
                 <p><router-link to="/service/detail/web-development" class="dropdown-item" @click="closeNavbar"> <img :src="require('/src/assets/images/webdevelopment.png')" class="width-40" /> <strong>Web Development</strong></router-link>
                  
                  <a href="/service/detail/web-development#technologies-we-use" class="dropdown-item ml11" @click="closeNavbar">Technologies We Use</a>
                  <a href="/service/detail/web-development#our-development-process" class="dropdown-item ml11" @click="closeNavbar">Our Development Process</a>
                </p>
             
                 <p class="digital-nav"><router-link to="/service/detail/digital-marketing" class="dropdown-item" @click="closeNavbar"> <img :src="require('/src/assets/images/digitalmarketing.png')" class="width-40" /> <strong>Digital Marketing</strong></router-link>
                  
                  <a href="/service/detail/digital-marketing#our-digital-marketing-services" class="dropdown-item ml11" @click="closeNavbar"> Our Digital Marketing Services</a>
                  <a href="/service/detail/digital-marketing#technologies-tools-we-use" class="dropdown-item ml11" @click="closeNavbar">Technologies & Tools We Use</a>
                  <a href="/service/detail/digital-marketing#our-process" class="dropdown-item ml11" @click="closeNavbar">Our Process</a> 
                </p> 
                </div>
                <div class="col-md-3 ">
                 <p> <router-link to="/service/detail/web-design" class="dropdown-item" @click="closeNavbar"> <img :src="require('/src/assets/images/web-design.png')" class="width-40" /> <strong>Web Design</strong></router-link>
                  
                  <a href="/service/detail/web-design#our-web-design-expertise" class="dropdown-item ml11" @click="closeNavbar"> Our Web Design Expertise</a>
                  <a href="/service/detail/web-design#technologies-we-use-for-superior-web-design" class="dropdown-item ml11" @click="closeNavbar"> Technologies We Use</a>
                  <a href="/service/detail/web-design#our-design-process" class="dropdown-item ml11" @click="closeNavbar"> Our Design Process</a>
                 </p>
                </div>
              </div>
            </div>
          </li>

          <li class="nav-item">
            <router-link to="/achievements" class="nav-link" @click="closeNavbar">Achievements</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/portfolio" class="nav-link" @click="closeNavbar">Work</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/careers" class="nav-link" @click="closeNavbar">Careers</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/blogs" class="nav-link" @click="closeNavbar">Blog</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/contact-us" class="nav-link" @click="closeNavbar">Contact</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { Collapse } from "bootstrap/dist/js/bootstrap.bundle.min.js";

export default {
  name: "HeaderComponent",
  data() {
    return {
      isScrolled: false,
      isNavbarOpen: false,
      collapseInstance: null,
      activeMenu: null,
      activeSubMenu: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("click", this.handleClickOutside);
    this.collapseInstance = new Collapse(this.$refs.navbarNav, { toggle: false });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    handleClickOutside(event) {
      const navbar = this.$refs.navbarNav;
      const toggler = this.$refs.navbarToggler;
      if (
        this.isNavbarOpen &&
        navbar &&
        toggler &&
        !navbar.contains(event.target) &&
        !toggler.contains(event.target)
      ) {
        this.closeNavbar();
      }
      
      if (this.activeSubMenu && !event.target.closest(".dropdown-container")) {
        this.closeSubMenu();
      }
    },
    toggleNavbar() {
      this.isNavbarOpen = !this.isNavbarOpen;
      if (this.collapseInstance) {
        this.isNavbarOpen ? this.collapseInstance.show() : this.collapseInstance.hide();
      }
    },
    closeNavbar() {
      this.isNavbarOpen = false;
      if (this.collapseInstance) {
        this.collapseInstance.hide();
      }
      this.closeMenu();
      this.closeSubMenu();
    },
    openMenu(menu) {
      this.activeMenu = menu;
    },
    closeMenu() {
      this.activeMenu = null;
    },
    toggleSubMenu(subMenu) {
      this.activeSubMenu = this.activeSubMenu === subMenu ? null : subMenu;
    },
    closeSubMenu() {
      this.activeSubMenu = null;
    },
  },
};
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

}

.mega-dropdown:hover .mega-menu {
  display: block;
}
@media (max-width: 768px) {
  .mega-dropdown:hover .mega-menu {
  display: block;height: 60vh;overflow-y: auto;overflow-x:hidden;
}}
.dropdown-container {
  position: relative;
}

.sub-menu {
  position: absolute;
  left: 100%;
  top: 0;
  width: 100%;
  background: white;
  display: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dropdown-container .sub-menu {
  display: block;
}

.dropdown-item {
  display: block;
  padding: 8px 12px;
  color: #333;
  text-decoration: none;
}

.dropdown-item:hover {
  background: #f0f0f0;
}
</style>
